import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';

export const groundPointSymbol = new SimpleMarkerSymbol({ color: 'blue', size: 6 });
export const invisiblePointSymbol = new SimpleMarkerSymbol({
  color: undefined,
  size: 2,
  style: 'cross',
  outline: { color: undefined },
});
export const nonTinablePointSymbol = new SimpleMarkerSymbol({
  color: 'red',
  size: 4,
  style: 'cross',
  outline: { color: 'red' },
});
export const inactivePointSymbol = new SimpleMarkerSymbol({
  color: 'black',
  size: 2,
  style: 'circle',
  outline: { color: 'black' },
});
export const tinablePointSymbol = new SimpleMarkerSymbol({
  color: 'green',
  size: 6,
  style: 'cross',
  outline: { color: 'green' },
});

export const breaklineSymbol = new SimpleLineSymbol({ width: 2, marker: { style: 'arrow', placement: 'end' } });

export const resultLineSymbol = new SimpleLineSymbol({ color: 'blue', width: 2 });

export const validNextPointSymbol = new SimpleMarkerSymbol({ color: 'green' });
export const validNextLineSymbol = new SimpleLineSymbol({ width: 2, color: 'green' });

export const invalidNextPointSymbol = new SimpleMarkerSymbol({ style: 'x', outline: { color: 'red' } });
export const invalidNextLineSymbol = new SimpleLineSymbol({ width: 2, color: 'red' });
